module.exports = __webpack_public_path__ + "img/oracle.8219cfb5.svg";